var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 36,
    viewBox: "0 0 46 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_1606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.54322 0C6.96548 0 5.05811 2.25614 5.14349 4.70295C5.22542 7.05366 5.11899 10.0981 4.35252 12.5809C3.58375 15.0709 2.28359 16.6483 0.159912 16.8508V19.1372C2.28359 19.3397 3.58375 20.9171 4.35252 23.4072C5.11899 25.8899 5.22542 28.9344 5.14349 31.2851C5.05811 33.7315 6.96548 35.988 9.5436 35.988H35.9565C38.5343 35.988 40.4412 33.7319 40.3559 31.2851C40.2739 28.9344 40.3804 25.8899 41.1468 23.4072C41.916 20.9171 43.2127 19.3397 45.3364 19.1372V16.8508C43.2127 16.6483 41.916 15.0709 41.1468 12.5809C40.3804 10.0985 40.2739 7.05366 40.3559 4.70295C40.4412 2.25653 38.5343 0 35.9565 0H9.54284H9.54322ZM30.788 22.1529C30.788 25.522 28.275 27.5653 24.1046 27.5653H17.0054C16.5825 27.5653 16.2397 27.2225 16.2397 26.7996V9.18843C16.2397 8.76555 16.5825 8.42273 17.0054 8.42273H24.064C27.5414 8.42273 29.8236 10.3064 29.8236 13.1984C29.8236 15.2283 28.2884 17.0457 26.3324 17.3638V17.4699C28.9951 17.762 30.788 19.6058 30.788 22.1529ZM23.3305 10.85H19.2826V16.5675H22.6919C25.3274 16.5675 26.7807 15.5062 26.7807 13.6092C26.7807 11.8316 25.5311 10.85 23.3305 10.85ZM19.2826 18.8363V25.1373H23.4794C26.2233 25.1373 27.677 24.0362 27.677 21.9669C27.677 19.8972 26.1827 18.8359 23.3029 18.8359H19.2826V18.8363Z",
    fill: "#7E13F8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_1606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.1765,
    height: 36,
    fill: "white",
    transform: "translate(0.159912)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.2f6f259367041285b809dd071e0bc560.svg";
export { ForwardRef as ReactComponent };